import * as React from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import allTeamMembers from "../../staticQueries/allTeamMembers"
import { TCategory, TTeamMember } from "../../types"

export type TeamListProps = {
  title: string
  categories: TCategory[]
}

const filterTeams = (teamMembers: TTeamMember[], categories: TCategory[]) => {
  const list: TTeamMember[] = []
  teamMembers.forEach((teamMember) => {
    const TeamCategorySlugs = teamMember.categories
      .map(category => category.slug)
    const categorySlugs = categories
      .map(category => category.slug)
    if(TeamCategorySlugs.some(r => categorySlugs.includes(r))) {
      list.push(teamMember)
    }
  })
  list.forEach((teamMember) => {
    if(teamMember.title) {
      teamMember.orderOn = teamMember.title
    } else {
      teamMember.orderOn = teamMember.name
    }
  })
  list.sort((a, b) => a.orderOn > b.orderOn ? 1 : -1)
  return list
}

export default function TeamList(props: TeamListProps) {
  const teamMembersList = filterTeams(allTeamMembers(), props.categories)
  return (
    <section>
      <h2>{props.title}</h2>
      {teamMembersList.map((member) => (
        <div key={member.id} style={{ display: "flex", gap: 16, marginBottom: 32 }}>
          <div style={{ width: 88, height: 88, borderRadius: 88, overflow: "hidden" }}>
            <GatsbyImage
              alt={member.avatar.title}
              image={getImage(member.avatar)}
            />
          </div>
          <div>
            <h3 style={{ margin: 0 }}>{member.name} {member.title || null}</h3>
            {member.thirdStoneTitle && (
              <>{member.thirdStoneTitle}<br /></>
            )}
            <h4 style={{ margin: "8px 0 0 0", fontSize: "1.1em", fontWeight: "normal" }}>{member.company}</h4>
            {member.occupationTitle}
          </div>
        </div>
      ))}
    </section>
  )
}

export const query = graphql`
  fragment TeamListContent on TeamList {
    title
    categories {
      slug
    }
  }
`